import React from "react";
import { Outlet, NavLink, Navigate } from "react-router-dom";
import Header from "@/components/app/Header";
import SEO from "@/components/app/SEO";
import { useAuth } from "@/context/AuthContext";
import { LayoutDashboard, Users, Briefcase, TrendingUp, Wallet } from "lucide-react";
import { Toaster } from "@/components/ui/sonner";

const items = [
  { to: "/courtier", icon: LayoutDashboard, label: "Tableau de bord", end: true },
  { to: "/courtier/clients", icon: Users, label: "Mes clients" },
  { to: "/courtier/dossiers", icon: Briefcase, label: "Dossiers" },
  { to: "/courtier/statistiques", icon: TrendingUp, label: "Statistiques" },
  { to: "/courtier/paiements", icon: Wallet, label: "Paiements" },
];

export default function BrokerLayout() {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center">Chargement...</div>;
  if (!user) return <Navigate to="/connexion" replace />;
  if (user.role !== "broker") return <Navigate to="/espace" replace />;

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <SEO title="Espace courtier" noindex />
      <Header />
      <div className="mx-auto max-w-7xl w-full px-4 sm:px-6 lg:px-8 py-8 flex-1">
        <div className="grid grid-cols-1 md:grid-cols-[220px_1fr] gap-8">
          <aside className="md:sticky md:top-24 h-fit">
            <nav className="flex flex-col gap-1">
              {items.map((it) => (
                <NavLink
                  key={it.to}
                  to={it.to}
                  end={it.end}
                  data-testid={`broker-sidebar-${it.to.split("/").pop()}`}
                  className={({ isActive }) =>
                    `flex items-center gap-3 px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 ${
                      isActive ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:text-foreground hover:bg-secondary"
                    }`
                  }
                >
                  <it.icon className="h-4 w-4" />
                  {it.label}
                </NavLink>
              ))}
            </nav>
          </aside>
          <div><Outlet /></div>
        </div>
      </div>
      <Toaster position="top-right" richColors />
    </div>
  );
}
